import "./hoverBtn.css";

export function HoverButton({ type = "button", onClick, children }: { type?: "button" | "submit"; onClick?: React.MouseEventHandler<HTMLButtonElement>; children: React.ReactNode }) {
  return (
    <button type={type} onClick={onClick} className="btn btn-hover">
      {children}
    </button>
  );
}
